import type { View } from '../platform/route';
export function BottomTabs({view, onNavigate}: {view: View; onNavigate: (v: View) => void}) {
  const active = view === 'preparation' ? 'home' : view === 'timeline' ? 'takes' : view === 'receipt' ? 'preflight' : view;
  return <nav className="bottom-tabs" aria-label="주요 메뉴">{([['home','오늘'],['rules','요강'],['takes','영상'],['preflight','제출']] as [View,string][]).map(([id,label]) => <button key={id} aria-current={active === id ? 'page' : undefined} onClick={() => onNavigate(id)}>{label}</button>)}</nav>;
}
